/* ===========================================
   SITEWIDE CONVERSION OPTIMIZATION
   Rubber Matting Direct - Maximum Sales
   =========================================== */

(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', init);
  
  function init() {
    addTrustBar();
    enhanceProductPages();
    enhanceCartPage();
    enhanceCollectionPages();
    addExitIntent();
    addScrollProgress();
    trackEngagement();
  }
  
  function addTrustBar() {
    if (document.querySelector('.rmd-trust-bar')) return;
    const header = document.querySelector('.header, header, [data-section-type="header"]');
    if (!header) return;
    
    const trustBarHTML = '<div class="rmd-trust-bar"><div class="rmd-trust-bar__inner"><div class="rmd-trust-bar__item"><svg viewBox="0 0 24 24"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg><span>Free UK Delivery</span></div><div class="rmd-trust-bar__item"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg><span>Same Day Dispatch</span></div><div class="rmd-trust-bar__item"><svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg><span>30 Day Returns</span></div><div class="rmd-trust-bar__item"><svg viewBox="0 0 24 24"><path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg><span>Secure Checkout</span></div></div></div>';
    header.insertAdjacentHTML('afterend', trustBarHTML);
  }
  
  function enhanceProductPages() {
    if (!document.querySelector('.product-template, [data-section-type="product"]')) return;
    addProductServices();
    addProductUrgency();
    addStickyMobileATC();
    handleVariantAvailability();
  }
  
  /* Variant Availability - Hide/disable unavailable option combinations */
  function handleVariantAvailability() {
    // Get product JSON from page
    var productJsonEl = document.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
    if (!productJsonEl) {
      // Try finding it in the page scripts
      var scripts = document.querySelectorAll('script');
      for (var i = 0; i < scripts.length; i++) {
        var text = scripts[i].textContent;
        if (text.indexOf('"variants"') > -1 && text.indexOf('"options"') > -1) {
          try {
            var match = text.match(/var\s+\w+\s*=\s*({[^;]+});/);
            if (match) {
              var product = JSON.parse(match[1]);
              if (product.variants) {
                initVariantAvailability(product);
                return;
              }
            }
          } catch (e) {}
        }
      }
      return;
    }
    
    try {
      var product = JSON.parse(productJsonEl.textContent);
      initVariantAvailability(product);
    } catch (e) {
      console.error('Variant availability: Could not parse product JSON', e);
    }
  }
  
  function initVariantAvailability(product) {
    if (!product || !product.variants || !product.options) return;
    
    var variants = product.variants;
    var options = product.options;
    
    // Build a map of which option values are valid for each combination
    function getAvailableValues(optionIndex, selectedValues) {
      var available = {};
      variants.forEach(function(v) {
        // Check if this variant matches all OTHER selected options
        var matches = true;
        for (var i = 0; i < options.length; i++) {
          if (i === optionIndex) continue; // Skip the option we're checking
          var selectedVal = selectedValues[i];
          if (selectedVal && v['option' + (i + 1)] !== selectedVal) {
            matches = false;
            break;
          }
        }
        if (matches) {
          available[v['option' + (optionIndex + 1)]] = true;
        }
      });
      return available;
    }
    
    function getCurrentSelections() {
      var selections = [];
      options.forEach(function(opt, index) {
        var selector = document.querySelector('[data-option-position="' + (index + 1) + '"] input:checked, [data-option-position="' + (index + 1) + '"] select, select[data-option="option' + (index + 1) + '"], .product-form__option[data-index="option' + (index + 1) + '"] input:checked');
        if (selector) {
          selections[index] = selector.value || selector.getAttribute('value');
        } else {
          // Try finding by option name
          var nameSelector = document.querySelector('[data-option="' + opt.name + '"] input:checked, select[data-option="' + opt.name + '"]');
          if (nameSelector) {
            selections[index] = nameSelector.value;
          }
        }
      });
      return selections;
    }
    
    function updateOptionAvailability() {
      var selections = getCurrentSelections();
      
      options.forEach(function(opt, optIndex) {
        var availableVals = getAvailableValues(optIndex, selections);
        
        // Find all inputs/options for this option
        var inputs = document.querySelectorAll(
          '[data-option-position="' + (optIndex + 1) + '"] input, ' +
          '[data-option="' + opt.name + '"] input, ' +
          '.product-form__option[data-index="option' + (optIndex + 1) + '"] input'
        );
        
        inputs.forEach(function(input) {
          var value = input.value;
          var label = input.closest('label') || document.querySelector('label[for="' + input.id + '"]');
          
          if (!availableVals[value]) {
            // Unavailable - grey out
            if (label) {
              label.style.opacity = '0.4';
              label.style.pointerEvents = 'none';
              label.style.textDecoration = 'line-through';
              label.title = 'Not available with current selection';
            }
            input.disabled = true;
          } else {
            // Available - restore
            if (label) {
              label.style.opacity = '';
              label.style.pointerEvents = '';
              label.style.textDecoration = '';
              label.title = '';
            }
            input.disabled = false;
          }
        });
        
        // Also handle select dropdowns
        var selects = document.querySelectorAll(
          '[data-option-position="' + (optIndex + 1) + '"] select, ' +
          'select[data-option="' + opt.name + '"], ' +
          'select[data-option="option' + (optIndex + 1) + '"]'
        );
        
        selects.forEach(function(select) {
          Array.from(select.options).forEach(function(option) {
            if (!availableVals[option.value]) {
              option.disabled = true;
              option.textContent = option.value + ' (unavailable)';
            } else {
              option.disabled = false;
              option.textContent = option.value;
            }
          });
        });
      });
    }
    
    // Listen for variant changes
    document.querySelectorAll('.product-form input[type="radio"], .product-form select, .product-form__option input').forEach(function(el) {
      el.addEventListener('change', function() {
        setTimeout(updateOptionAvailability, 50);
      });
    });
    
    // Also listen for the custom variant change event if used by theme
    document.addEventListener('variant:changed', function() {
      setTimeout(updateOptionAvailability, 50);
    });
    
    // Initial update
    setTimeout(updateOptionAvailability, 100);
  }
  
  function addProductServices() {
    const servicesHTML = '<div class="rmd-product-services" style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;margin:24px 0;padding:20px 0;border-top:1px solid #E8E8E8;border-bottom:1px solid #E8E8E8;"><div style="display:flex;align-items:center;gap:10px;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.06em;color:#666;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B4D3E" stroke-width="1.5"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>Free UK Delivery</div><div style="display:flex;align-items:center;gap:10px;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.06em;color:#666;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B4D3E" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>Same Day Dispatch</div><div style="display:flex;align-items:center;gap:10px;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.06em;color:#666;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B4D3E" stroke-width="1.5"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>30 Day Returns</div><div style="display:flex;align-items:center;gap:10px;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.06em;color:#666;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B4D3E" stroke-width="1.5"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>UK Support</div></div>';
    const priceEl = document.querySelector('.product-form__info-list, .product-meta__price, .price-list');
    if (priceEl && !document.querySelector('.rmd-product-services')) {
      priceEl.insertAdjacentHTML('afterend', servicesHTML);
    }
  }
  
  function addProductUrgency() {
    var hour = new Date().getHours();
    var text = hour < 14 ? 'Order in the next <strong>' + (14-hour) + ' hour' + (14-hour>1?'s':'') + '</strong> for same day dispatch' : 'Order now for <strong>next working day</strong> dispatch';
    var urgencyHTML = '<div class="rmd-product-urgency" style="background:#F0F7F4;padding:14px 16px;margin:16px 0;font-size:0.85rem;color:#1B4D3E;text-align:center;border-radius:6px;">' + text + ' · Free UK delivery</div>';
    var addBtn = document.querySelector('.product-form__add-button, .btn--add-to-cart');
    if (addBtn && !document.querySelector('.rmd-product-urgency')) {
      var container = addBtn.closest('.product-form__payment-container') || addBtn.parentElement;
      container.insertAdjacentHTML('afterend', urgencyHTML);
    }
  }
  
  function addStickyMobileATC() {
    if (window.innerWidth > 768 || document.querySelector('.rmd-sticky-atc')) return;
    
    var addBtn = document.querySelector('.product-form__add-button, .btn--add-to-cart, button[name="add"]');
    var priceEl = document.querySelector('.price-list .price, .price--highlight, .product-meta__price .price');
    if (!addBtn) return;
    
    var price = priceEl ? priceEl.textContent.trim() : '';
    
    var stickyDiv = document.createElement('div');
    stickyDiv.className = 'rmd-sticky-atc';
    stickyDiv.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#fff;padding:12px 16px;padding-bottom:calc(12px + env(safe-area-inset-bottom));box-shadow:0 -4px 20px rgba(0,0,0,0.15);z-index:99998;display:flex;align-items:center;gap:12px;transform:translateY(100%);transition:transform 0.3s ease;';
    
    var priceDiv = document.createElement('div');
    priceDiv.style.cssText = 'font-size:1.1rem;font-weight:700;color:#1B4D3E;';
    priceDiv.textContent = price;
    
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rmd-sticky-atc-btn';
    btn.style.cssText = 'flex:1;background:linear-gradient(135deg,#1B4D3E 0%,#2d7a62 100%);color:#fff;border:none;padding:14px 20px;font-size:0.85rem;font-weight:600;text-transform:uppercase;letter-spacing:0.08em;cursor:pointer;border-radius:4px;';
    btn.textContent = 'ADD TO BAG';
    
    stickyDiv.appendChild(priceDiv);
    stickyDiv.appendChild(btn);
    document.body.appendChild(stickyDiv);
    
    window.addEventListener('scroll', function() {
      var rect = addBtn.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 100;
      stickyDiv.style.transform = visible ? 'translateY(100%)' : 'translateY(0)';
    });
    
    btn.addEventListener('click', function() {
      btn.textContent = 'ADDING...';
      addBtn.click();
      setTimeout(function() { btn.textContent = 'ADD TO BAG'; }, 1500);
    });
  }
  
  function enhanceCartPage() {
    if (!document.querySelector('.cart-template, [data-section-type="cart"]')) return;
    addCartTrust();
  }
  
  function addCartTrust() {
    var trustHTML = '<div class="rmd-cart-trust" style="background:#F0F7F4;padding:16px;border-radius:8px;margin:16px 0;"><div style="font-weight:600;margin-bottom:12px;color:#1B4D3E;">Why Shop With Us</div><div style="display:grid;gap:8px;font-size:0.9rem;"><div>✓ Free UK Delivery</div><div>✓ Same Day Dispatch</div><div>✓ 30 Day Returns</div><div>✓ Secure Checkout</div></div></div>';
    var checkoutBtn = document.querySelector('.cart__checkout-btn, .btn--checkout, [name="checkout"]');
    if (checkoutBtn && !document.querySelector('.rmd-cart-trust')) {
      var container = checkoutBtn.closest('.cart__footer, .cart__actions');
      if (container) container.insertAdjacentHTML('beforebegin', trustHTML);
    }
  }
  
  function enhanceCollectionPages() {
    if (!document.querySelector('.collection-template, [data-section-type="collection"]')) return;
    var productCount = document.querySelectorAll('.product-item').length;
    var title = document.querySelector('.collection__title, h1');
    if (title && productCount > 0 && !document.querySelector('.rmd-product-count')) {
      title.insertAdjacentHTML('afterend', '<span class="rmd-product-count" style="display:block;font-size:0.8rem;font-weight:400;color:#999;margin-top:8px;">' + productCount + ' Products</span>');
    }
  }
  
  function addExitIntent() {}
  
  function addScrollProgress() {
    if (!document.querySelector('.product-template')) return;
    var bar = document.createElement('div');
    bar.className = 'rmd-scroll-progress';
    bar.style.cssText = 'position:fixed;top:0;left:0;width:0%;height:3px;background:linear-gradient(90deg,#1B4D3E,#2d7a62);z-index:9999;transition:width 0.1s;';
    document.body.insertBefore(bar, document.body.firstChild);
    window.addEventListener('scroll', function() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = Math.min((scrollTop/docHeight)*100, 100) + '%';
    });
  }
  
  function trackEngagement() {
    document.querySelectorAll('.product-form__add-button, .btn--add-to-cart').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (typeof gtag !== 'undefined') gtag('event', 'add_to_cart_click', {event_category:'engagement'});
      });
    });
  }
  
})();

